import { render } from "./PubAdmin.vue?vue&type=template&id=49f909f2"
import script from "./PubAdmin.vue?vue&type=script&lang=js"
export * from "./PubAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__